<template>
  <el-container style="height: 100vh">
    <el-header v-if="isLoggedIn">
      <el-menu :default-active="$route.path" mode="horizontal" @select="handleSelect" class="header-menu">
        <el-menu-item index="/inventory">库存管理</el-menu-item>
        <el-menu-item index="/orders">订单管理</el-menu-item>
        <el-menu-item index="/shop-manage">店铺管理</el-menu-item>
        <el-menu-item index="/announcements" v-if="permission === 1">公告管理</el-menu-item>
        <el-menu-item index="/order-search" v-if="permission === 1 || permission === 10">检索订单</el-menu-item>
        <!-- 右侧用户信息区域 -->
        <div class="user-info">
          <el-tag type="" class="user-tag">当前账号：{{ account }}</el-tag>
          <el-tag v-if="!isAdmin" type="success" class="role-tag">店铺名称：{{ shopname }}</el-tag>
          <el-button type="danger" size="small" @click="logout" class="logout-btn">退出登录</el-button>
        </div>
      </el-menu>
    </el-header>
    <el-main>
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'App',
  computed: {
    account() {
      return this.$user.account;
    },
    permission() {
      return this.$user.permission;
    },
    shopname() {
      return this.$user.shopname;
    },
    isLoggedIn() {
      return this.$user.isLoggedIn();
    },
    isAdmin() {
      return this.permission == 1 || this.permission == 100;
    }
  },
  methods: {
    handleSelect(index) {
      if (this.$route.path !== index) {
        // 权限检查
        if (index === '/order-search' && this.permission !== 1 && this.permission !== 10) {
          this.$message.error('你无权查看本页面');
          return;
        }
        if (this.$user.permission > 1 && index !== '/shop-manage' && index !== '/orders' && index !== '/order-search') {
          this.$message.error('你无权查看本页面');
          return;
        }
        this.$router.push(index)
      }
    },
    logout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$user.logout();
        this.$message.success('已退出登录');
        this.$router.push('/login');
      }).catch(() => {
        // 用户取消退出
      });
    }
  }
}
</script>

<style>
body {
  margin: 0;
}

.user-info {
  display: flex;
  justify-self: end;
  align-items: center;
  margin-right: 30px;
  margin-top: 15px;
  /* width: 400px; */
  /* border: 1px solid red; */
}

.user-tag {
  margin-right: 10px;
}

.role-tag {
  margin-right: 10px;
}
</style>
